import React, { FunctionComponent } from 'react'
import styled from 'styled-components'
import { AutoImage } from '../components/auto-image'
import { BannerImage } from '../components/banner-image'
import { BlogSection } from '../components/blog-section'
import { ContentContainer } from '../components/content-container'
import { DecoratedFrame } from '../components/decorated-frame'
import { HeadBannar } from '../components/head-bannar'
import { Section } from '../components/section'
import { DiagramContainer, DiagramItem, ItemTitle, ItemText } from '../components/section-diagram'
import { SectionNavigator } from '../components/section-navigator'
import { SectionSpaceLarge, SectionSpaceMedium } from '../components/section-space'
import { SectionTextExtraLarge, SectionTextMedium, SectionTextSmall } from '../components/section-text'
import { SectionTitle } from '../components/section-title'

const Outer = styled.div``

type KidsAmiPageProps = {

}
export const KidsAmiPage: FunctionComponent<KidsAmiPageProps> = () => {
  return <Outer>

    <HeadBannar desktop={() => <BannerImage src="/images/header_03.jpg" />} mobile={() => <BannerImage src="/images/header_03_mobile.jpg" />}></HeadBannar>
    <ContentContainer>
      {/* <SectionNavigator labelMap={new Map([['about', 'About us'], ['diagram', '概念図']])} /> */}
      <Section id="about">
        <SectionTitle>About us</SectionTitle>
        <SectionSpaceMedium />
        <DecoratedFrame leftBottom="/images/dec_03_01.png" rightTop="/images/dec_03_02.png">
          <AutoImage src="/images/img_04.jpg" mobileSrc="/images/img_04_mobile.jpg" />
          <AutoImage src="/images/img_05.jpg" mobileSrc="/images/img_05_mobile.jpg" />
        </DecoratedFrame>
        <SectionSpaceMedium />
        <SectionTextSmall>
          認定こども園ムロノキッズでは、3歳未満の保育を必要とする子ども向けに<br />
          プリスクール室の木と小規模保育所キッズアミの2つの施設で受入れ体制を整えています。<br />
          それぞれの施設で各歳の受入れ定員の規模は違いますが、<br />
          同一内容で保育を実践し、0歳から2歳までの子ども達の健やかな成長をサポートし、<br />
          3歳以降の幼児教育を見据えて集団生活の中で主体的に行動出来るよう生活リズムを整えています。
        </SectionTextSmall>
      </Section>
      <Section id="diagram">
        <DiagramContainer>
          <DiagramItem>
            <ItemTitle>プリスクール室の木・<br />キッズアミ</ItemTitle>
            <ItemText>
              プリスクール室の木・キッズアミは共に横浜市が支給認定の決定をする3号認定児の対象施設です。3号認定とは、3歳児未満で保育の必要性がある子どもたちを指します。両親が共働きであったり、妊娠・出産で保育が必要という場合に横浜市に申請して3号認定を受けることができます。<br />
              保育の必要性の程度は、ご家庭の状況によって変わり、保育短時間認定（8時間）と保育標準時間認定（11時間）があります。延長保育もありますので、開園時間の範囲で認定された時間を超えた利用も可能です。<br />
              これら2つの施設の違いは、3歳に進級する際にプリスクール室の木の在園児は2号認定として、キッズアミの在園児は1号認定としてそれぞれ進級するところにあります。ただし、室の木幼稚園3-5歳に記載がある通り、預かり保育が活用できますので、2号認定児同等時間の保育が可能です。
            </ItemText>
          </DiagramItem>
        </DiagramContainer>
      </Section>
      <BlogSection where={{categoryName: 'pre-school'}} where2={{categoryName: 'kids-ami'}} />
    </ContentContainer>
  </Outer>
}